export const darkThemeCssSelectors =
  'html[data-theme="dark"],html.dark-theme,body.dark-theme,html.theme-dark,body.theme-dark'
